import { Component } from '@angular/core';

@Component({
  selector: 'app-history-orders',
  templateUrl: './history-orders.component.html',
  styleUrls: ['./history-orders.component.scss','../historical/historical.component.scss']
})
export class HistoryOrdersComponent {

}
